export const revealEditorialPanel = (panel: HTMLElement | null): boolean => {
  if (!panel) return false;
  panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
};
